import { render } from "./SolutionsWizardProgramm.vue?vue&type=template&id=612f98bb"
import script from "./SolutionsWizardProgramm.vue?vue&type=script&lang=js"
export * from "./SolutionsWizardProgramm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/SolutionsWizardProgramm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "612f98bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('612f98bb', __exports__)) {
    api.reload('612f98bb', __exports__)
  }
  
  module.hot.accept("./SolutionsWizardProgramm.vue?vue&type=template&id=612f98bb", () => {
    api.rerender('612f98bb', render)
  })

}


export default __exports__